const MODE_CONFIG = {
  // 汤机
  "BOIL_WATER": {
    desc: "它是相同的电水壶功能，温度默认为100度，无法设置时间，这个程序将在温度达到100度时结束。",
    icon: require("@/assets/soup/boil_water.png"),
    activeIcon: require("@/assets/soup/boil_water_active.png")
  },
  "FOOD_PROCESSOR": {
    desc: "当需要用圆盘研磨或切片，或用刀片切碎时，请选择此方式。工作参数:速度3-5/时间0s-lmin",
    icon: require("@/assets/soup/food_processor.png"),
    activeIcon: require("@/assets/soup/food_processor_active.png")
  },
  "ADAPTED_COOKING": {
    desc: "对于没有明确规定的一般烹饪，可以选择此模式设置参数。",
    icon: require("@/assets/soup/diy.png"),
    activeIcon: require("@/assets/soup/diy_active.png")
  },
  "KNEAD_TOUGH": {
    desc: "这是一个揉面团的功能。顺时针旋转27秒，停3秒，反转27秒，停3秒，共运行3分钟。",
    icon: require("@/assets/soup/dough.png"),
    activeIcon: require("@/assets/soup/dough_active.png")
  },
  "1602L_KNEAD": {
    desc: "这是一个揉面团的功能。顺时针旋转27秒，停3秒，反转27秒，停3秒，共运行3分钟。",
    icon: require("@/assets/soup/dough.png"),
    activeIcon: require("@/assets/soup/dough_active.png")
  },
  "STEAM": {
    desc: "当温度到了95度后才会倒计时，同自动程序中的蒸汽程序",
    icon: require("@/assets/soup/steam.png"),
    activeIcon: require("@/assets/soup/steam_active.png")
  },
  "1602L_STEAM": {
    desc: "当温度到了95度后才会倒计时，同自动程序中的蒸汽程序",
    icon: require("@/assets/soup/steam.png"),
    activeIcon: require("@/assets/soup/steam_active.png")
  },
  "SLOW_COOK": {
    desc: "该模式适用于一些需要低速长时间烹饪的食谱",
    icon: require("@/assets/soup/slow_cook.png"),
    activeIcon: require("@/assets/soup/slow_cook_active.png")
  },
  "1602L_SLOW_COOKING": {
    desc: "该模式适用于一些需要低速长时间烹饪的食谱",
    icon: require("@/assets/soup/slow_cook.png"),
    activeIcon: require("@/assets/soup/slow_cook_active.png")
  },
  "DESCRIPTION": {
    desc: "它是不需要任何设备操作的步骤",
    icon: require("@/assets/soup/desc.png"),
    activeIcon: require("@/assets/soup/desc_active.png")
  },
  "WEIGHT":  {
    desc: "这一步是为了放多少配料进行称重的步骤。",
    icon: require("@/assets/soup/weight.png"),
    activeIcon: require("@/assets/soup/weight_active.png")
  },
  "CHOP": {
    desc: "用于绞肉机或剁碎。工作参数：速度1-12/时间10秒-4分钟。",
    icon: require("@/assets/soup/chop.png"),
    activeIcon: require("@/assets/soup/chop_active.png")
  },
  "BROWN": {
    desc: "以设定的速度5秒开25秒停，但是加热程序一直工作",
    icon: require("@/assets/soup/brown.png"),
    activeIcon: require("@/assets/soup/brown_active.png")
  },
  "SPECIAL_DIY_MODE": {
    desc: "烹饪时间/温度/速度跟普通模式一致，时间只有在到达设定温度后才会倒计时。",
    icon: require("@/assets/soup/special.png"),
    activeIcon: require("@/assets/soup/special_active.png")
  },
  "WARNING":  {
    desc: "提醒用户操作注意事项。",
    icon: require("@/assets/soup/warning.png"),
    activeIcon: require("@/assets/soup/warning_active.png")
  },
  "FERMENT":  {
    // desc: "给牛奶发酵提供一个恒定温度的环境，温度37-65℃之间，在这个环境下， 益生菌大量繁殖，牛奶中乳糖转化成乳酸，牛奶发酵成酸奶。",
    desc: "给牛奶发酵提供一个恒定温度的环境",
    icon: require("@/assets/soup/ferment.png"),
    activeIcon: require("@/assets/soup/ferment_active.png")
  },

  "ADAPTED_COOKING_HEAT": {
    desc: "对于没有明确规定的一般烹饪，可以选择此模式设置参数。0-100℃调用烧水的加热逻辑，100℃以上调用原来的DIY加热逻辑。",
    icon: require("@/assets/soup/diy.png"),
    activeIcon: require("@/assets/soup/diy_active.png")
  },
  "1602L_DIY": {
    desc: "对于没有明确规定的一般烹饪，可以选择此模式设置参数。0-100℃调用烧水的加热逻辑，100℃以上调用原来的DIY加热逻辑。",
    icon: require("@/assets/soup/diy.png"),
    activeIcon: require("@/assets/soup/diy_active.png")
  },
  "2002_DIY": {
    desc: "对于没有明确规定的一般烹饪，可以选择此模式设置参数。0-100℃调用烧水的加热逻辑，100℃以上调用原来的DIY加热逻辑。",
    icon: require("@/assets/soup/diy.png"),
    activeIcon: require("@/assets/soup/diy_active.png")
  },

  // 空炸
  "AF_WARNING":  {
    desc: "提醒用户操作注意事项。",
    icon: require("@/assets/soup/warning.png"),
    activeIcon: require("@/assets/soup/warning_active.png")
  },
  "AF_WEIGHT":  {
    desc: "对食材，调料进行称重。",
    icon: require("@/assets/soup/weight.png"),
    activeIcon: require("@/assets/soup/weight_active.png")
  },

  "AF_DIY": {
    desc: "对于没有明确规定的一般烹饪，可以选择此模式设置参数。多汁、多油的食材选择用空炸盘盛放；偏干性、体积大或需要不断翻面的食材用空炸锅直接加热。",
    icon: require("@/assets/af/diy.png"),
    activeIcon: require("@/assets/af/diy_active.png")
  },
  "AF_AIR_FRYER": {
    desc: "适用炸薯条、薯片类的功能，可选择空炸锅或空炸盘盛放食材加热。",
    icon: require("@/assets/af/fryer.png"),
    activeIcon: require("@/assets/af/fryer_active.png")
  },
  "AF_DESCRIPTION": {
    desc: "它是不需要任何设备操作的步骤",
    icon: require("@/assets/af/description.png"),
    activeIcon: require("@/assets/af/description_active.png")
  },
  "AF_BAKE": {
    desc: "适用烤面包的功能，面包直接放于空炸锅中烘烤，烘烤过程进行翻面效果更佳。",
    icon: require("@/assets/af/bake.png"),
    activeIcon: require("@/assets/af/bake_active.png")
  },
  "AF_DRUMSTICKS": {
    desc: "适用炸鸡腿的功能。直接放于空炸锅中，烘烤过程进行翻面效果更佳。",
    icon: require("@/assets/af/drumsticks.png"),
    activeIcon: require("@/assets/af/drumsticks_active.png")
  },
  "AF_EGG_TART": {
    desc: "适用烤蛋挞的功能，放于空炸盘中烘烤",
    icon: require("@/assets/af/egg_tart.png"),
    activeIcon: require("@/assets/af/egg_tart_active.png")
  },
  "AF_PIZZA": {
    desc: "适用烤披萨的功能，调好的披萨放于空炸锅中烘烤",
    icon: require("@/assets/af/pizza.png"),
    activeIcon: require("@/assets/af/pizza_active.png")
  },
  "AF_DEHYDRATE": {
    desc: "适用对食物做脱水的功能，例如柠檬片，红枣等食材。",
    icon: require("@/assets/af/dehydrate.png"),
    activeIcon: require("@/assets/af/dehydrate_active.png")
  },
  "AF_REHEAT": {
    desc: "适用对食物进行再次加热的功能。",
    icon: require("@/assets/af/reheat.png"),
    activeIcon: require("@/assets/af/reheat_active.png")
  },
  "AF_CHICKEN_WING": {
    desc: "适用烤鸡翅的功能，放于空炸盘中烘烤",
    icon: require("@/assets/af/chicken_wing.png"),
    activeIcon: require("@/assets/af/chicken_wing_active.png")
  },
  "AF_STEAK": {
    desc: "适用烤牛排的功能，放于空炸盘中烘烤，烘烤过程进行翻面效果更佳。",
    icon: require("@/assets/af/steak.png"),
    activeIcon: require("@/assets/af/steak_active.png")
  },
  "AF_SEA_FOOD": {
    desc: "适用烤海鲜的功能，例如虾，鱼等食材，放于空炸盘中加热",
    icon: require("@/assets/af/sea_food.png"),
    activeIcon: require("@/assets/af/sea_food_active.png")
  },
  "AF_VEGETABLE": {
    desc: "适用烤蔬菜类的功能，例如茄子，青菜等食材，放于空炸盘中加热",
    icon: require("@/assets/af/vegetable.png"),
    activeIcon: require("@/assets/af/vegetable_active.png")
  },
  "AF_MUTTON_CHOP": {
    desc: "适用烤羊排，排骨的功能，放于空炸盘中烘烤，烘烤过程进行翻面效果更佳",
    icon: require("@/assets/af/mutton_chop.png"),
    activeIcon: require("@/assets/af/mutton_chop_active.png")
  },
  "AF_SPECIAL_DIY_MODE": {
    desc: "预热空炸锅，到达设定的温度后会停止",
    icon: require("@/assets/soup/special.png"),
    activeIcon: require("@/assets/soup/special_active.png")
  },

  // 厨师机
  "SM_DIY": {
    desc: "对于没有明确规定的一般烹饪，可以选择此模式设置参数。",
    icon: require("@/assets/soup/diy.png"),
    activeIcon: require("@/assets/soup/diy_active.png")
  },
  "SM_DESCRIPTION": {
    desc: "它是不需要任何设备操作的步骤",
    icon: require("@/assets/soup/desc.png"),
    activeIcon: require("@/assets/soup/desc_active.png")
  },
  "SM_WEIGHT": {
    desc: "对食材，调料进行称重。",
    icon: require("@/assets/soup/weight.png"),
    activeIcon: require("@/assets/soup/weight_active.png")
  },
  "SM_KNEAD": {
    desc: "其主要功能是将面粉和水进行均匀的混合，通过搅拌和揉制，使干性面粉得到均匀的水化作用，扩展面筋，成为具有一定弹性、伸缩性和流动均匀的面团",
    icon: require("@/assets/sm/knead.png"),
    activeIcon: require("@/assets/sm/knead_active.png")
  },
  "SM_WHISK": {
    desc: "可以将蛋白、黄油、奶油这些材料用打蛋器或厨师机搅拌，使大量空气进入材料中，在加热过程中使成品膨胀，口感绵软。",
    icon: require("@/assets/sm/whisk.png"),
    activeIcon: require("@/assets/sm/whisk_active.png")
  },
  "SM_BEATER": {
    desc: "将多种原料进行搅拌混合，使之成为一种混合物状态。",
    icon: require("@/assets/sm/beater.png"),
    activeIcon: require("@/assets/sm/beater_active.png")
  },
  "SM_SHREDDER": {
    desc: "原料被送入刀具的切割区域，随着刀具的旋转，原料被切割成细长的丝状。",
    icon: require("@/assets/sm/shredder.png"),
    activeIcon: require("@/assets/sm/shredder_active.png")
  },
  "SM_MEAT_GRUBDER": {
    desc: "利用转动的切刀刃的剪切作用将原料肉切碎",
    icon: require("@/assets/sm/meat_grubder.png"),
    activeIcon: require("@/assets/sm/meat_grubder_active.png")
  },
  "SM_BLENDER": {
    desc: "轻松快速地制作果泥或冰沙。",
    icon: require("@/assets/sm/blender.png"),
    activeIcon: require("@/assets/sm/blender_active.png")
  },
  "SM_PASTA_MAKER": {
    desc: "由两个旋转的辊子组成，将面团放入辊子之间，通过旋转的辊子将面团压成所需的厚度",
    icon: require("@/assets/sm/pasta_maker.png"),
    activeIcon: require("@/assets/sm/pasta_maker_active.png")
  },
  "SM_WARNING": {
    desc: "提醒用户操作注意事项。",
    icon: require("@/assets/soup/warning.png"),
    activeIcon: require("@/assets/soup/warning_active.png")
  },

  // 新的
  "SM_HEAT_DIY": {
    desc: "对于有温度设定的烹饪，可以选择此模式设置参数。",
    icon: require("@/assets/sm/heat-diy.jpg"),
    activeIcon: require("@/assets/sm/heat-diy.active.jpg")
  },
  "SM_FERMENTED_DOUGH": {
    desc: "其主要功能是通过恒温、恒湿的条件来培育酵母菌，从而让面团得以迅速发酵，出现蜂窝组织，膨大、松软。",
    icon: require("@/assets/sm/fermented_dough.png"),
    activeIcon: require("@/assets/sm/fermented_dough_active.png")
  },
  "SM_MELT_CHOCOLATE": {
    desc: "通过搅拌和加热来融化巧克力。",
    icon: require("@/assets/sm/melt_chocolate.png"),
    activeIcon: require("@/assets/sm/melt_chocolate_active.png")
  },
  "SM_SWISS_MERINGUE": {
    desc: "加热蛋清和糖再通过打蛋浆搅拌使之降温",
    icon: require("@/assets/sm/swiss_meringue.png"),
    activeIcon: require("@/assets/sm/swiss_meringue_active.png")
  },
  "SM_ITALIAN_MERINGUE": {
    desc: "高温加热糖浆后加入蛋白中使用打蛋浆进行搅打",
    icon: require("@/assets/sm/italian_meringue.png"),
    activeIcon: require("@/assets/sm/italian_meringue_active.png")
  },
  "SM_GLACE_FRUIT": {
    desc: "在搅拌碗中加入水果，糖和水，加热并搅拌均匀",
    icon: require("@/assets/sm/glace_fruit.png"),
    activeIcon: require("@/assets/sm/glace_fruit_active.png")
  },
  "SM_STEWED": {
    desc: "加热搅拌，温度到达后时间开始倒计时",
    icon: require("@/assets/sm/stewed.png"),
    activeIcon: require("@/assets/sm/stewed_active.png")
  },
  "SM_NOURISHING_SOUP": {
    desc: "加热搅拌，温度到达后时间开始倒计时",
    icon: require("@/assets/sm/nourishing_soup.png"),
    activeIcon: require("@/assets/sm/nourishing_soup_active.png")
  },
  "SM_SLOW_COOK": {
    desc: "该模式适用于一些需要低速长时间烹饪的食谱",
    icon: require("@/assets/sm/slow_cook.png"),
    activeIcon: require("@/assets/sm/slow_cook_active.png")
  },
  "SM_BOIL_WATER": {
    desc: "温度默认为100℃，无法设置时间，这个程序将在温度到达100度时结束",
    icon: require("@/assets/soup/boil_water.png"),
    activeIcon: require("@/assets/soup/boil_water_active.png")
  },



  // 烤箱
  "OVEN_ADAPTED_COOKING": {
    desc: "自主设定参数，根据不同的食材可选择不同的加热方式以及配件",
    icon: require("@/assets/af/diy.png"),
    activeIcon: require("@/assets/af/diy_active.png")
  },
  "OVEN_PREHEAT": {
    desc: "如果设了时间值，则时间到了就结束程序，如果设定温度，没有设时间，则温度到了就结束程序。",
    icon: require("@/assets/soup/special.png"),
    activeIcon: require("@/assets/soup/special_active.png")
  },
  /*"O_ROAST": {
    desc: "适用于烤整鸡、鱼之类的大型食材，配合转又或烤盘使用",
    icon: require("@/assets/oven/roast.png"),
    activeIcon: require("@/assets/oven/roast_active.png")
  },
  "O_GRILL": {
    desc: "适用于烤鸡中翅、虾之类的小型食材，配合烤盘使用",
    icon: require("@/assets/oven/grill.png"),
    activeIcon: require("@/assets/oven/grill_active.png")
  },
  "O_BAKE": {
    desc: "适用于烤面包、曲奇饼干类的食材，配合烤盘使用",
    icon: require("@/assets/oven/bake.png"),
    activeIcon: require("@/assets/oven/bake_active.png")
  },
  "O_FRENCH_FRIES": {
    desc: "针对鲜切、冷冻薯条设定的功能，将食材放于烤盘，再放入腔体的中层或顶层烤",
    icon: require("@/assets/oven/french_fries.png"),
    activeIcon: require("@/assets/oven/french_fries_active.png")
  },
  "O_PIZZA": {
    desc: "针对披萨制定的程序，将披萨放于烤盘，再放入腔体的中层或顶层烤",
    icon: require("@/assets/oven/pizza.png"),
    activeIcon: require("@/assets/oven/pizza_active.png")
  },
  "O_TOAST": {
    desc: "针对吐司制定的程序，配合烤网使用，具有不同的上色等级提供选择",
    icon: require("@/assets/oven/toast.png"),
    activeIcon: require("@/assets/oven/toast_active.png")
  },
  "O_DEHYDRATE": {
    desc: "对食材进行烘干。比如红枣、葡萄干等食材，防止食材表面变色，烘干的温度一般选择 60-80℃。",
    icon: require("@/assets/oven/dehydrate.png"),
    activeIcon: require("@/assets/oven/dehydrate_active.png")
  },*/
  "O_DESCRIPTION": {
    desc: "它是不需要任何设备操作的步骤",
    icon: require("@/assets/soup/desc.png"),
    activeIcon: require("@/assets/soup/desc_active.png")
  },
}

// 根据请求回来的字典数据过滤
export const filterModeByDict = (list) => {
  if(!Array.isArray(list)) return [];
  return list.map(item => {
    return {
      ...item,
      ...MODE_CONFIG[item.value]
    }
  })
}


